import React from 'react';
import { formatMessage } from '../../CurrentLocale';
import { Wrapper } from './style';
import RSS from '../../assets/images/square-rss-solid-full.svg';

class RSSFluxButton extends React.Component {
  getRssUrlWithParams = () => {
    const searchParams = window.location.search;
    const baseRssUrl = `${process.env.REACT_APP_BASE_PATH}/rss`;
    return `${baseRssUrl}${searchParams}`;
  };

  render() {
    return (
      <Wrapper>
        <a
          className="button--rss"
          href={this.getRssUrlWithParams()}
        >
          <img
            className="button--rss__img"
            src={RSS}
            alt={formatMessage({ id: 'rssFlux.button' })}
            loading="lazy"
          />
          {formatMessage({ id: 'rssFlux.button' })}
        </a>
      </Wrapper>
    );
  }
}

export default RSSFluxButton;


// WEBPACK FOOTER //
// ./src/components/RSSFluxButton/index.js